import { render } from "./BoxLevel.vue?vue&type=template&id=73d84ce2&scoped=true"
import script from "./BoxLevel.vue?vue&type=script&lang=js"
export * from "./BoxLevel.vue?vue&type=script&lang=js"

import "./BoxLevel.vue?vue&type=style&index=0&id=73d84ce2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d84ce2"]])

export default __exports__